import Cookies from "js-cookie"

export const IMPERSONATION_COOKIE = "impersonate_user"

export const isImpersonating = () =>
  Cookies.get(IMPERSONATION_COOKIE) !== undefined

export const impersonatedUserId = () =>
  isImpersonating() && Cookies.get(IMPERSONATION_COOKIE)
